var exports = {
  "kL": "x4c3adb35--06c02e--container",
  "_8": "x4c3adb35--06c02e--img",
  "p2": "x4c3adb35--06c02e--text-info",
  "qU": "x4c3adb35--06c02e--one-column",
  "Cv": "x4c3adb35--06c02e--two-column",
  "$p": "x4c3adb35--06c02e--services",
  "oJ": "x4c3adb35--06c02e--work",
  "UU": "x4c3adb35--06c02e--name",
  "s6": "x4c3adb35--06c02e--agent-name",
  "Tq": "x4c3adb35--06c02e--participations",
  "qS": "x4c3adb35--06c02e--badge",
};

module.exports = exports;
